//@flow
import React, {forwardRef} from 'react';
import {Alert} from '@material-ui/lab';
import {Typography, makeStyles} from '@material-ui/core';
import {colors} from '../../../../../assets/styles/colors';

const useStyles = makeStyles(() => ({
  root: {
    marginBottom: '1rem',
  },
  title: {
    fontWeight: 600,
    marginBottom: '.5rem',
  },
  list: {
    margin: 0,
    paddingLeft: '1.25rem',
    color: colors.grey900,
  },
  item: {
    marginBottom: '.25rem',
  },
}));

type Props = {
  messages: string[],
  onClose?: () => void,
};

function ValidationAlert({messages, onClose}: Props, ref: any) {
  const classes = useStyles();

  if (!messages.length) return null;

  const uniqueMessages = [...new Set(messages)];

  return (
    <div ref={ref}>
      <Alert severity="error" className={classes.root} onClose={onClose}>
        <Typography className={classes.title}>
          Revisa los siguientes campos antes de guardar:
        </Typography>
        <ul className={classes.list}>
          {uniqueMessages.map(message => (
            <li key={message} className={classes.item}>
              {message}
            </li>
          ))}
        </ul>
      </Alert>
    </div>
  );
}

export default (forwardRef(ValidationAlert): any);
